import { useRef, useCallback } from 'react';

const defaultOptions = {};
function useDoubleTap(cbProp, threshold = 300, options = defaultOptions) {
  const timer = useRef(null);
  const onSingleTapRef = useRef(options.onSingleTap);
  onSingleTapRef.current = options.onSingleTap;
  const callbackRef = useRef(cbProp);
  callbackRef.current = cbProp;
  const handler = useCallback((event) => {
    if (!timer.current) {
      timer.current = setTimeout(() => {
        if (onSingleTapRef.current) {
          onSingleTapRef.current(event);
        }
        timer.current = null;
      }, threshold);
    } else {
      clearTimeout(timer.current);
      timer.current = null;
      callbackRef.current?.(event);
    }
  }, [
    threshold
  ]);
  return cbProp ? {
    onClick: handler
  } : {};
}

export { useDoubleTap };
//# sourceMappingURL=useDoubleTap.js.map
